const aaa = [
	{
		path: "huifangList",
		component: () => import("@/views/huifang/huifang/list.vue"),
		meta:{title:'回访'},
	},
]
export default aaa;